import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { createPortal } from "react-dom";
import { HomepageSectionType, Orientation, } from "../../types/global";
import CategoriesSwiper from "../homepage/CategoriesSwiper";
import GenericButton from "../helpers/GenericButton";
import { ROUTES } from "../../constants/routes";
import SearchLayerSectionSwiper from "./SearchLayerSectionSwiper";
import useTailwindBreakpoint from "../../hooks/useTailwindBreakpoint";
export default function SearchByTagLayer({ data, onClose }) {
    const isLg = useTailwindBreakpoint("lg");
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        const id = requestAnimationFrame(() => setMounted(true));
        document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
            cancelAnimationFrame(id);
        };
    }, []);
    const landscapeContents = data?.video?.filter((contentItem) => {
        const info = typeof contentItem.info === "string"
            ? JSON.parse(contentItem.info)
            : contentItem.info;
        return info?.is_vod_vertical === Orientation.Landscape;
    }) ?? [];
    const portraitContents = data?.video?.filter((contentItem) => {
        const info = typeof contentItem.info === "string"
            ? JSON.parse(contentItem.info)
            : contentItem.info;
        return info?.is_vod_vertical === Orientation.Portrait;
    }) ?? [];
    const catalogueContents = data.folders?.flatMap((item) => {
        return {
            id: item.id,
            title: item.title,
            description: item.description,
            redirect_url: ROUTES.VIEWFOLDER(item.id),
            image: JSON.stringify({ landscape: item.thumb }),
        };
    }) ?? [];
    const catalogueSection = {
        type: HomepageSectionType.Categories,
        title: "",
        cover_orientation: Orientation.Landscape,
        content_list: catalogueContents,
    };
    return createPortal(_jsxs("div", { className: `${mounted ? "animate-in fade-in-0 duration-300" : "animate-out fade-out-0 duration-300"} supports-backdrop-filter:bg-background/60 pointer-events-auto fixed inset-0 z-49 min-h-screen min-w-screen overflow-x-hidden overflow-y-scroll py-10 backdrop-blur-lg **:no-underline md:py-16`, children: [_jsx("div", { className: "mt-4 mr-5 flex flex-row justify-end md:mr-10", children: _jsx("div", { onClick: onClose, children: _jsx(GenericButton, { variant: "close", size: isLg ? "md" : "sm", icon: true }) }) }), _jsxs("div", { className: "mt-6 ml-3 flex flex-col gap-2 md:mt-8 md:ml-18 md:gap-4", children: [catalogueContents.length > 0 && (_jsx(CategoriesSwiper, { data: catalogueSection, loadOnEnd: false, navigation: {
                            prevPosition: "left-0 -translate-x-1/2",
                            nextPosition: "right-6",
                        }, isSearchSection: true })), landscapeContents.length > 0 && (_jsx(SearchLayerSectionSwiper, { data: landscapeContents, slideOrientation: Orientation.Landscape })), portraitContents.length > 0 && (_jsx(SearchLayerSectionSwiper, { data: portraitContents, slideOrientation: Orientation.Portrait }))] })] }), document.body);
}
